module.exports = __webpack_public_path__ + "e048e77175526e162fad3989c6d0fdf9.png";